import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { OrderPreparationStatusName } from "../../../../../../services/Api/Organization/types";
import { NumberOrderApi } from "../../../../../../services/Api/Public/types";
import { getOrderPreparationStatusColor } from "../../../../../App/pages/Organization/pages/LiveOrders/services/orderStatus";

interface Props {
	item: NumberOrderApi;
}

const NumberSystemCardMobile = ({ item }: Props) => {
	const { t } = useTranslation();

	const getPreparationStatusName = () => {
		if (item.status === OrderPreparationStatusName.READY) {
			return t("modules.number_system.field.ready.title");
		}
		return t(`enums.preparation_statuses.${item.status}`);
	};

	return (
		<Card
			className="number-system-card-mobile"
			style={{ backgroundColor: getOrderPreparationStatusColor(item.status) }}
		>
			<Card.Body>
				<div className="d-flex flex-column">
					<h1>{item.order_number}</h1>
					<p className="mb-0">{getPreparationStatusName().toUpperCase()}</p>
				</div>
			</Card.Body>
		</Card>
	);
};

export default NumberSystemCardMobile;
